export const state = () => ({
    features: null,
})

export const getters = {
    hasDropshippingFeature(state, getters, rootState, rootGetters) {
        return (
            rootGetters['global/account']?.isEligibleForDropshipping ||
            rootGetters['global/isSupplier']
        )
    },

    hasDropshippingApiFeature(state, getters, rootState, rootGetters) {
        return state?.features?.includes('ds-api')
    },
    hasOneBrandFeature(state) {
        return !!state?.features?.includes('no-ds-marketplace')
    },
}

export const mutations = {
    updateFeatures(state, payload) {
        state.features = payload
    },
}
